import { useEffect, useRef } from "react";
import { usePostHog } from "@posthog/react";
import { useLocation } from "react-router-dom";

import { Env } from "../common/constants";
import { useAppSelector } from "../hooks/useAppSelector";

const PageViewTracker = () => {
  const posthog = usePostHog();
  const location = useLocation();
  const email = useAppSelector(
    (s) => s.login.email || s.myProfile.myProfileData?.email || "",
  );

  const lastRouteCaptureKeyRef = useRef<string>("");

  useEffect(() => {
    if (!Env.POSTHOG_KEY || !posthog || !email) return;
    if (Env.MODE !== "pre-prod" && Env.MODE !== "production") return;

    posthog.identify(email, { email });
  }, [posthog, email]);

  useEffect(() => {
    if (!Env.POSTHOG_KEY || !posthog) return;
    if (Env.MODE !== "pre-prod" && Env.MODE !== "production") return;

    const captureKey = `${location.pathname}${location.search}|${email}`;
    if (lastRouteCaptureKeyRef.current === captureKey) return;
    lastRouteCaptureKeyRef.current = captureKey;

    posthog.capture("$pageview", {
      email: email || undefined,
      path: location.pathname,
      search: location.search || undefined,
      href: window.location.href,
    });
  }, [location.pathname, location.search, posthog, email]);

  return null;
};

export default PageViewTracker;
